// AcademicYearModal.jsx (исправленная версия)
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AcademicYearModal = ({ 
  isOpen, 
  onClose, 
  academicYearData, 
  onSubmit,
  viewMode = false,
  isEditPossible = true 
}) => {
  const getDefaultDates = (year) => {
    const baseYear = year || new Date().getFullYear();
    return {
      groupFormationStart: `${baseYear}-02-15`,
      publicDisplayStart: `${baseYear}-03-15`,
      invitationStart: `${baseYear}-04-01`,
      childTransferStart: `${baseYear}-08-15`
    };
  };

  const [formData, setFormData] = useState({
    name: '',
    year: '',
    groupFormationStart: '',
    publicDisplayStart: '',
    invitationStart: '',
    childTransferStart: ''
  });

  useEffect(() => {
    if (academicYearData) {
      setFormData({
        name: academicYearData.name || '',
        year: academicYearData.year || '',
        groupFormationStart: academicYearData.groupFormationStart || '',
        publicDisplayStart: academicYearData.publicDisplayStart || '',
        invitationStart: academicYearData.invitationStart || '',
        childTransferStart: academicYearData.childTransferStart || ''
      });
    } else {
      const currentYear = new Date().getFullYear();
      const defaultDates = getDefaultDates(currentYear);
      
      setFormData({
        name: '',
        year: '',
        groupFormationStart: defaultDates.groupFormationStart,
        publicDisplayStart: defaultDates.publicDisplayStart,
        invitationStart: defaultDates.invitationStart,
        childTransferStart: defaultDates.childTransferStart
      });
    }
  }, [academicYearData, isOpen]);

  const handleYearChange = (e) => {
    const yearValue = e.target.value;
    const nameValue = yearValue ? `${yearValue}-${parseInt(yearValue) + 1}` : '';
    
    setFormData(prev => ({
      ...prev,
      year: yearValue,
      name: nameValue // Автоматически заполняем name
    }));
    
    if (yearValue && yearValue.length === 4) {
      const defaultDates = getDefaultDates(yearValue);
      
      // Автоматично заповнюємо дати за замовчуванням для нового року
      if (!academicYearData) {
        setFormData(prev => ({
          ...prev,
          groupFormationStart: defaultDates.groupFormationStart,
          publicDisplayStart: defaultDates.publicDisplayStart,
          invitationStart: defaultDates.invitationStart,
          childTransferStart: defaultDates.childTransferStart
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Убеждаемся что поле name заполнено
    const submitData = {
      ...formData,
      name: formData.name || (formData.year ? `${formData.year}-${parseInt(formData.year) + 1}` : '')
    };
    
    if (onSubmit) {
      onSubmit(submitData);
    } else {
      console.log('Збереження даних:', submitData);
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {viewMode 
            ? 'Перегляд навчального року' 
            : academicYearData 
              ? 'Редагувати навчальний рік' 
              : 'Додати новий навчальний рік'
          }
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Навчальний рік {!viewMode && '*'}</Form.Label>
            <Form.Control
              type="number"
              name="year"
              value={formData.year}
              onChange={handleYearChange}
              required={!viewMode}
              min="2000"
              max="2100"
              placeholder="Введіть рік (наприклад: 2025)"
              disabled={viewMode || !isEditPossible}
              readOnly={viewMode}
            />
            {formData.name && (
              <Form.Text className="text-muted">
                Назва: <strong>{formData.name}</strong>
              </Form.Text>
            )}
          </Form.Group>

          {/* Скрытое поле name */}
          <Form.Control
            type="hidden"
            name="name"
            value={formData.name}
            required={!viewMode}
          />

          <Form.Group className="mb-3">
            <Form.Label>Дата початку формування груп {!viewMode && '*'}</Form.Label>
            <Form.Control
              type="date"
              name="groupFormationStart"
              value={formData.groupFormationStart}
              onChange={handleChange}
              required={!viewMode}
              disabled={viewMode || !isEditPossible}
              readOnly={viewMode}
            />
            <Form.Text className="text-muted">
              За замовчуванням: 15 лютого
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Дата публічного показу груп у системі садочків {!viewMode && '*'}</Form.Label>
            <Form.Control
              type="date"
              name="publicDisplayStart"
              value={formData.publicDisplayStart}
              onChange={handleChange}
              required={!viewMode}
              disabled={viewMode || !isEditPossible}
              readOnly={viewMode}
            />
            <Form.Text className="text-muted">
              За замовчуванням: 15 березня
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Дата початку розсилки запрошень {!viewMode && '*'}</Form.Label>
            <Form.Control
              type="date"
              name="invitationStart"
              value={formData.invitationStart}
              onChange={handleChange}
              required={!viewMode}
              disabled={viewMode || !isEditPossible}
              readOnly={viewMode}
            />
            <Form.Text className="text-muted">
              За замовчуванням: 1 квітня
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Дата початку переведення дітей на наступний навчальний рік {!viewMode && '*'}</Form.Label>
            <Form.Control
              type="date"
              name="childTransferStart"
              value={formData.childTransferStart}
              onChange={handleChange}
              required={!viewMode}
              disabled={viewMode || !isEditPossible}
              readOnly={viewMode}
            />
            <Form.Text className="text-muted">
              За замовчуванням: 15 серпня
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            {viewMode ? 'Закрити' : 'Скасувати'}
          </Button>
          {!viewMode && isEditPossible && (
            <Button variant="primary" type="submit" disabled={!formData.name}>
              {academicYearData ? 'Зберегти зміни' : 'Додати навчальний рік'}
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AcademicYearModal;